import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  applyAutoSlip,
  applySlip,
  getInitFormData,
  getNoSlip,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showPopupModal } from "@widgets/CommonModal";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SN_SAL_COL_REG_002_POP_001 from "@menu/SAL/SN_SAL_COL_REG_002/SN_SAL_COL_REG_002_POP_001";
import SN_SAL_COL_REG_002_POP_002 from "@menu/SAL/SN_SAL_COL_REG_002/SN_SAL_COL_REG_002_POP_002";
import { dateToString } from "@shared/utils/DateUtils";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";

interface Props {
  Menuprops: menuInfo;
}

const SN_SAL_COL_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });

  const [selectedTabPage, setTapPage] = useState<string>("1");
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedDtDocu, setSelectedDtDocu] = useState<string>("");

  useEffect(() => {
    const fetchform = async () => {
      try {
        const defaultForm = {
          cd_biz: userInfo.cd_biz,
          cd_emp: userInfo.cd_emp,
          nm_emp: userInfo.nm_emp,
        };
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...({ ...rtn.formData, ...defaultForm } || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    const modifiedRowsL2 = gridRefs.current["grid3"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = await onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    try {
      const params = {
        id: "sn_sal_col_reg_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      gridRefs.current["grid1"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRowH = (): any => {
    try {
      const modifiedRowsH =
        gridRefs.current["grid1"].current.getChange().insert;
      if (modifiedRowsH.length > 0) {
        showDialog("alter", "진행중인 건을 먼저 처리하세요.");
        return false;
      }

      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        no_col_s: "",
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_col_s: today,
        fg_trns: "1",
        cd_fin: "",
        am_sales: 0,
        am_col_s: 0,
        cd_cust: "",
        nm_cust: "",
        nm_cust_sort: "",
        yn_docu: "N",
      };
      if (searchInfo.cd_cust !== "") {
        updatedRow.cd_cust = searchInfo.cd_cust;
        updatedRow.nm_cust = searchInfo.nm_cust;
        updatedRow.nm_cust_sort = searchInfo.nm_cust_sort;
      }

      return updatedRow;
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow = () => {
    try {
      return gridRefs.current["grid2"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRowL = (): any => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");

      return {
        cd_firm: userInfo.cd_firm,
        no_line: maxNoLine + 1,
        no_col_s: focusedNodeH.data?.no_col_s,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow2 = () => {
    try {
      return gridRefs.current["grid3"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRowL2 = (): any => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      return {
        cd_firm: userInfo.cd_firm,
        no_col_s: focusedNodeH.data?.no_col_s,
        am_re: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (focusedNodeH.data?.yn_docu === "Y") {
      showDialog("alter", "회계 처리된 건은 삭제할 수 없습니다.");
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid3"].current?.deleteAllRows();
    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow = async () => {
    const rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    if (rowCount === 0) return;

    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (focusedNodeH.data?.yn_docu === "Y") {
      showDialog("alter", "회계 처리된 건은 삭제할 수 없습니다.");
      return;
    }

    gridRefs.current["grid2"].current?.deleteSelectedRows();

    await gridRefs.current["grid2"].current.refreshFooter();
    const footerData = gridRefs.current["grid2"].current.getFooterData();

    await getFooterFromGrid2(gridRefs.current["grid1"].current, footerData);
  };

  const onDeleteRow2 = async () => {
    const rowCount = gridRefs.current["grid3"].current?.getDisplayedRowCount();
    if (rowCount === 0) return;

    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (focusedNodeH.data?.yn_docu === "Y") {
      showDialog("alter", "회계 처리된 건은 삭제할 수 없습니다.");
      return;
    }

    gridRefs.current["grid3"].current?.deleteSelectedRows();

    await gridRefs.current["grid3"].current.refreshFooter();
    const footerData = gridRefs.current["grid3"].current.getFooterData();

    await getFooterFromGrid3(gridRefs.current["grid1"].current, footerData);
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();
      gridRefs.current["grid3"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL1 =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL1) return false;

      const requiredValuesCheckL2 =
        gridRefs.current["grid3"].current.requiredValuesCheck();
      if (!requiredValuesCheckL2) return false;

      const salColshChanges = gridRefs.current["grid1"].current.getChange();
      const salColslChanges = gridRefs.current["grid2"].current.getChange();
      const salColsdChanges = gridRefs.current["grid3"].current.getChange();

      const headerInserts = salColshChanges.insert ?? [];
      const lineInserts = salColslChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      if (
        salColshChanges.modifiedRowcount === 0 &&
        salColslChanges.modifiedRowcount === 0 &&
        salColsdChanges.modifiedRowcount === 0
      ) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      // const lineDeletes = salColslChanges.delete ?? [];
      // const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      // if (lineDeletes.length > 0 && rowCount === 0) {
      //   gridRefs.current["grid1"].current.deleteRowByIndex(
      //     focusedRowNodeH.rowIndex
      //   );
      // }

      let noSlip: any;
      if (headerInserts.length > 0) {
        noSlip = await applySlip({
          cd_column: "no_col_s",
          cd_module: Menuprops.cd_module,
          no_line: 5,
          cd_prefix: "COS",
          dt: focusedRowNodeH.data.dt_io,
          girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
          inserts: [salColshChanges, salColslChanges],
          cd_menu: Menuprops.cd_menu,
        });

        gridRefs.current["grid3"].current?.forEachNode((node: any) => {
          if (node.data.no_col_s == "" || node.data.no_col_s == null) {
            node.setDataValue("no_col_s", noSlip);
          }
        });
        salColsdChanges.insert.forEach((row: any) => {
          if (row.no_col_s == "" || row.no_col_s == null) {
            row.no_col_s = noSlip;
          }
        });
      }

      const saveData = {
        sal_collectsh: salColshChanges,
        sal_collectsl: salColslChanges,
        sal_collectsd: salColsdChanges,
      };

      const ok = await fnSave("SN_SAL_COL_REG_002_SAVE_01", saveData);
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        gridRefs.current["grid3"].current.resetUpdate(true);
        return false;
      }

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid3"].current.resetUpdate(true);
      return false;
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedNodeH) return;

      if (focusedNodeH.data?.yn_docu === "Y") {
        showDialog("alter", "회계 처리된 건은 행 추가할 수 없습니다.");
        return;
      }

      if (focusedNodeH.data?.cd_cust === "") {
        showDialog("alter", "고객은 필수 입력 값입니다.");
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_firm: userInfo.cd_firm,
        cd_biz: selectedFormData.cd_biz,
        cd_cust: focusedNodeH.data?.cd_cust,
        nm_cust: focusedNodeH.data?.nm_cust_sort,
        fg_trns: focusedNodeH.data?.fg_trns,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
      };

      const component = (
        <SN_SAL_COL_REG_002_POP_001 selectedData={selectedData} />
      );

      const result = await showPopupModal({
        title: "선수금적용",
        children: component,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      if (headerResult) {
        headerResult.map((result: any) => {
          const addedNode = onAddRow();
          if (addedNode) {
            for (const key in result) {
              if (key === "no_line") continue;
              addedNode.setDataValue(key, result[key], "noEvent");
            }
            addedNode.setDataValue("am_target", result.am_re, "noEvent");
          }
        });
      }
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };

  const onGrid3BtnsClick = async (id: string) => {
    if (id === "addRow") {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedNodeH) return;

      if (focusedNodeH.data?.yn_docu === "Y") {
        showDialog("alter", "회계 처리된 건은 행 추가할 수 없습니다.");
        return;
      }

      const focusedNodeL = gridRefs.current["grid2"].current.focusedRowNode();
      if (!focusedNodeL) return;

      const modifiedRows2 = gridRefs.current["grid2"].current.getChange();
      if (modifiedRows2.modifiedRowcount > 0) {
        showDialog("alter", "수정중인 건이 있습니다.");
        return;
      }

      if (
        gridRefs.current["grid2"].current?.getFooterData().am_col_s -
          (focusedNodeH.data?.am_sales ?? 0) <
        1
      ) {
        showDialog("alter", "반제시킬 정상수금이 없습니다.");
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_firm: userInfo.cd_firm,
        cd_biz: selectedFormData.cd_biz,
        cd_cust: focusedNodeH.data?.cd_cust,
        nm_cust: focusedNodeH.data?.nm_cust_sort,
        nm_cust_sort: focusedNodeH.data?.nm_cust_sort,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
        fg_trns: focusedNodeH.data?.fg_trns,
      };
      const component = (
        <SN_SAL_COL_REG_002_POP_002 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "매출적용",
        children: component,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      if (headerResult) {
        headerResult.map((result: any) => {
          const addedNode = onAddRow2();
          if (addedNode) {
            for (const key in result) {
              if (key === "no_line") continue;
              addedNode.setDataValue(key, result[key], "noEvent");
            }
            addedNode.setDataValue("am_target", result.am_remin, "noEvent");
            addedNode.setDataValue("am_col_s", result.am_col, "noEvent");
          }
        });
      }
    }

    if (id === "deleteRow") {
      onDeleteRow2();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_col_s = selectedRow.no_col_s;
      const dt_col_s = selectedRow.dt_col_s || "";
      setSelectedDocu(no_col_s);
      setSelectedDtDocu(dt_col_s);
    }
  };

  const onTabChanged = (index: any) => {
    setTapPage(index);
  };

  const onCellValueChanged1 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();

    if (colId === "am_col_s" || colId === "am_target") {
      rowNode.setDataValue(
        "am_re",
        (rowData.am_target ?? 0) - (rowData.am_col_s ?? 0)
      );
    }
  };

  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();

    if (colId === "am_col_s" || colId === "am_target") {
      rowNode.setDataValue(
        "am_re",
        (rowData.am_target ?? 0) - (rowData.am_col_s ?? 0)
      );
    }

    await gridRefs.current["grid2"].current.refreshFooter();
    const footerData = gridRefs.current["grid2"].current.getFooterData();

    await getFooterFromGrid2(gridRefs.current["grid1"].current, footerData);
  };

  const getFooterFromGrid2 = async (gridApi: any, footerData: any) => {
    const focusedNode = gridApi.focusedRowNode();
    if (focusedNode) {
      focusedNode.setDataValue("am_col_s", footerData.am_col_s);
    }
  };

  const onCellValueChanged3 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();

    if (colId === "am_col_s") {
      rowNode.setDataValue(
        "am_re",
        (rowData.am_target ?? 0) - (rowData.am_col_s ?? 0)
      );
    }

    await gridRefs.current["grid3"].current.refreshFooter();
    const footerData = gridRefs.current["grid3"].current.getFooterData();

    await getFooterFromGrid3(gridRefs.current["grid1"].current, footerData);
  };

  const getFooterFromGrid3 = async (gridApi: any, footerData: any) => {
    const focusedNode = gridApi.focusedRowNode();
    if (focusedNode) {
      focusedNode.setDataValue("am_sales", footerData.am_col_s);
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChanged1,
          onBeforeAddRow: onBeforeAddRowH,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBeforeAddRow: onBeforeAddRowL,
          onBtnDeleteClick: onGrid2BtnsClick,
          onCellValueChanged: onCellValueChanged2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onBeforeAddRow: onBeforeAddRowL2,
          onCellValueChanged: onCellValueChanged3,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single" }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["no_col_s"],
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["수금내역", "반제내역"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            header={[
              <SnTabHeader
                onBtnAddClick={onGrid2BtnsClick}
                onBtnDeleteClick={onGrid2BtnsClick}
              />,
              <SnTabHeader
                onBtnAddClick={onGrid3BtnsClick}
                onBtnDeleteClick={onGrid3BtnsClick}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid2.events}
              />,
              <SnGrid
                ref={gridRefs.current["grid3"]}
                columnConfig={grids.grid3.columns}
                rowData={grids.grid3.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid3.events}
              />,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={0}
          selectedDtDocu={selectedDtDocu}
        />
      </div>
    </div>
  );
});

export default SN_SAL_COL_REG_002;
